<template>
  <div class="content">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="main_container">
      <div class="md_title mart24 marb12">知识产权概况</div>
      <v-row>
        <v-col>
          <div class="firm_chome_top">
            <ul>
              <li>
                <span>截止<i>{{ myChartsNum.lastCheck }}</i>日,园区共有<i>{{myChartsNum.row1NumPatentCompany}}</i>家企业拥有自主知识产权，企业累计专利总量为</span>
                <i>{{ myChartsNum.row1NumTotal}}</i>
                <span>项，其中授权发明专利</span>
                <i>{{ myChartsNum.row1NumTypeInventPublication }}</i>
                <!--"row2NumNewPatentCompany": 45, "row2NumNewPatentAmount": 8049, "row2NumNewPatentInventPublication": 1893, "row2NumNewPatentInventGrant": 703, "row2NumNewPatentUtility": 4062, "row2NumNewPatentDesign": 1391, "row2NumNewTMRegister": 0, "row2NumNewIC": 0, -->
                <span>项；公开发明专利</span>
                <i>{{ myChartsNum.row1NumTypeInventGrant }}</i>
                <span>项；授权实用新型</span>
                <i>{{ myChartsNum.row1NumTypeUtility }}</i>
                <span>项；授权外观设计</span>
                <i>{{ myChartsNum.row1NumTypeDesign }}</i>
                <span>项。园区企业已申请商标</span>
                <i>{{ myChartsNum.row1NumTMApplication }}</i>
                <span>项，其中注册商标为</span>
                <i>{{ myChartsNum.row1NumTMRegister }}</i>
                <span>项。园区企业集成电路布图设计共有</span>
                <i>{{ myChartsNum.row1NumIC }}</i>
                <span>项。</span>
                <!-- 家企业拥有自主知识产权，企业累计专利总量为<i>7855</i>项，其中授权发明专利<i>1179</i>项；公开发明专利<i>1513</i>项；授权实用新型<i>3791</i>项；授权外观设计<i>1364</i>项。园区企业已申请商标<i>11243</i>项，其中注册商标为<i>7506</i>项。园区企业集成电路布图设计共有
                            <i>8</i>项。 -->
              </li>
              <li>
                <span>本年度
                  <b style="font-style: normal;color:#FFB217;font-weight:bold;font-size: 14px;">{{ myChartsNum.lastCheck }}</b>
                  园区共有</span>
                <i>{{ myChartsNum.row2NumNewPatentCompany }}</i>
                <span>家企业有新增知识产权，今年新增专利总量为</span>
                <i>{{ myChartsNum.row2NumNewPatentAmount }}</i>
                <span>项，其中授权发明专利新增</span>
                <i>{{ myChartsNum.row2NumNewPatentInventPublication }}</i>
                <span>项；公开发明专利新增</span>
                <i>{{ myChartsNum.row2NumNewPatentInventGrant }}</i>
                <span>项；授权实用新型新增</span>
                <i>{{ myChartsNum.row2NumNewPatentUtility }}</i>
                <span>项；授权外观设计新增</span>
                <i>{{ myChartsNum.row2NumNewPatentDesign }}</i>
                <span>项。园区企业注册商标新增</span>
                <i>{{ myChartsNum.row2NumNewTMRegister }}</i>
                <span>项。园区企业集成电路布图设计新增</span>
                <i>{{ myChartsNum.row2NumNewIC }}</i>
                <span>项。</span>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
      <div class="firm_chome_center">
        <div class="row_style first_row">
          <div class="item rights">
            <div class="chart_item">
              <!-- <div class="tit_name">年度专利增长趋势</div> -->
              <div class="tit_name">年度专利申请趋势</div>
              <div class="chart_dom"
                   id="chart1"></div>
            </div>
          </div>
          <div class="item lefts">
            <div class="chart_item">
              <div class="tit_name">年度商标申请趋势</div>
              <div class="chart_dom"
                   id="chart2"></div>
            </div>
          </div>
        </div>
        <div class="row_style">
          <div class="item rights">
            <div class="chart_item">
              <div class="tit_name">集成电路申请趋势
              </div>
              <div class="chart_dom1"
                   id="chart3"></div>
            </div>
          </div>
          <div class="item centers">
            <div class="chart_item">
              <div class="tit_name">专利有效性分布</div>
              <div class="chart_dom1"
                   id="chart4"></div>
            </div>
          </div>
          <div class="item lefts">
            <div class="chart_item">
              <div class="tit_name">年度软著总数统计</div>
              <div class="chart_dom1"
                   id="chart5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import topNav from '@/components/widgets/topNav.vue'
import { mapActions } from 'vuex'
import { compileFunction } from 'vm'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      myChartsNum: {},
      myChart1: '',
      myChart2: '',
      myChart3: '',
      myChart4: '',
      myChart5: '',
      chartsList: [],
      dataAxis: [],
      dataAxis2: [],
      dataAxis5: [],
      data1: [],
      data2: [],
      datafourdata: [
        {
          value: '',
          name: '',
        },
      ],
      data5: {
        data5AxisY: [],
      },
      data3: [{}],
      data4: [],
      data8: {
        data8Num: [],
      },
    }
  },
  components: { topNav },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initChartSum()
        this.initChartGroup()
        this.initChartsChart()
        this.initChartsChartwo()
        this.initChartsCharthree()
        this.initChartsCharfour()
        this.initChartsCharfive()
        this.initChartEight() //集成电路的
      }, 20)
    })
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initChart()
        this.setChart1()
        this.setChart2()
        this.setChart3()
        this.setChart4()
        this.setChart5()
      }, 1000)
    })
  },
  methods: {
    ...mapActions('chome', [
      'getChartGroup',
      'getChartData',
      'getChartsummary',
    ]),
    //集团的基本信息
    initChartSum() {
      let _this = this
      let data = {
        params: {
          gid: 1,
        },
      }
      console.log('1-1')
      this.getChartsummary({
        data: data,
        handle(res) {
          let list = res.message
          _this.myChartsNum = res.message.data
          _this.myChartsNum.lastCheck = res.message.data.lastCheck.slice(0, 10)
        },
      })
    },
    initChartGroup() {
      let _this = this
      let data = {
        params: {
          gid: 1,
        },
      }

      this.getChartGroup({
        data: data,
        handle(res) {},
      })
    },
    initChartsCharttpl() {
      let _this = this
      let data = {
        params: {
          gid: 1,
        },
      }
      this.getChartGroup({
        data: data,
        handle(res) {
          let list = res.message
          _this.chartsList = res.message.data
          _this.chartsList.forEach((item) => {
            item.year = this.item.year = this
            // console.log(item.chartCode, '=========_this.chartCode===========')
            if (item.chartCode == 'pa_application_grant_trend') {
              // _this.chartsList = this.charts1
              // console.log(this.charts1, '========this.charts1=========')
            }
          })
          this.initChartsChart()
        },
      })
    },
    initChartsChart() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'pa_application_trend',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          // let outdata = JSON.stringify(res.data);
          _this.chartsdata = res.message.data
          let data1 = []
          let newyear = []
          _this.chartsdata.forEach((item) => {
            let num = item.num
            let year = item.year
            data1 = data1.concat(num)
            newyear = newyear.concat(year)
          })
          _this.dataAxis = newyear
          _this.data1 = data1
        },
      })
    },
    //年度商标申请趋势数据
    initChartsChartwo() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'tm_application_trend',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          _this.chartsdatatwo = res.message.data
          // console.log(_this.chartsdatatwo, '=======_this.chartsdatatwo======')
          let data2 = []
          let yearTwo = []
          let sum2 = []
          _this.chartsdatatwo.forEach((item) => {
            let data = item.data
            let year = item.year
            let sum = 0
            for (var d in data) {
              sum += data[d]
            }
            // console.log(sum, '======sum=')
            data2 = data2.concat(data)
            yearTwo = yearTwo.concat(year).sort()
            sum2 = sum2.concat(sum)
          })
          console.log(yearTwo, '====yearTwo====')
          _this.dataAxis2 = yearTwo
          _this.data2 = sum2
        },
      })
    },
    //集成电路申请趋势
    initChartEight() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'ic_application_trend',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          // console.log(res.message,'===res.message=====')
          _this.chartsEight = res.message.dataAcc
          let echararrEightNum = []
          for (var i = 0; i < _this.chartsEight.length; i++) {
            var arrindex = echararrEightNum.findIndex((item, index, arr) => {
              return item.year === _this.chartsEight[i].year
            }) //获取下标
            if (arrindex == -1) {
              echararrEightNum.push({
                year: _this.chartsEight[i].year,
                month: [_this.chartsEight[i].month],
                num: [_this.chartsEight[i].num],
              })
            } else {
              echararrEightNum[arrindex].month.push(_this.chartsEight[i].month)
              echararrEightNum[arrindex].num.push(_this.chartsEight[i].num)
            }
            let numApplication = []
            let numGrant = []
            let yearCharts = []
            echararrEightNum.forEach((item) => {
              let year = item.year
              let month = item.month
              let num = item.num
              let sumnApplication = 0
              let sumnGrant = 0
              for (var i in month) {
                sumnApplication += month[i]
              }
              numApplication = numApplication.concat(sumnApplication)
              for (var K in num) {
                sumnGrant += num[K]
              }
              numGrant = numGrant.concat(sumnGrant)
              yearCharts = yearCharts.concat(year)
            })
            _this.dataAxis8 = yearCharts
            _this.data8.data8Num = numGrant
          }
        },
      })
    },
    initChartsCharthree() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'pa_company_rank',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          console.log(res.message, '======res.message========')
          _this.chartsdatathree = res.message.data.slice(0, 10)
          console.log(
            _this.chartsdatathree,
            '=====(_this.chartsdatathree========'
          )
          let sum3 = []
          let data3 = []
          _this.chartsdatathree.forEach((item) => {
            let companyName = item.companyName
            let sum = item.sum
            // data3 = data3.concat(companyName)
            data3 = data3.concat(companyName)
            sum3 = sum3.concat(sum)
          })
          _this.sum3 = sum3
          _this.data3 = data3
        },
      })
    },
    initChartsCharfour() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'pa_valid_outline',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          _this.chartsdatafour = res.message.data
          //  datafourdata//饼状图的数据
          let datafourdata = []
          _this.datafourdata = _this.chartsdatafour.map((item) => {
            return {
              value: item.num,
              name: item.legalStatus,
            }
          })
          console.log(_this.datafourdata, '==== _this.datafourdata====')
        },
      })
    },
    initChartsCharfive() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          chartTplCode: 'rz_all_amount_outline',
        },
      }
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message
          _this.data = res.message.data
          let numFive = []
          let numFiveYear = []
          _this.data.forEach((item) => {
            let num = item.num
            let year = item.year
            numFive = numFive.concat(num)
            numFiveYear = numFiveYear.concat(year)
          })
          _this.dataAxis5 = numFiveYear
          _this.data5.data5AxisY = numFive
        },
      })
    },
    initChart() {
      //年度增长的趋势
      this.myChart1 = echarts.init(document.getElementById('chart1'))
      this.myChart2 = echarts.init(document.getElementById('chart2'))
      this.myChart3 = echarts.init(document.getElementById('chart3'))
      this.myChart4 = echarts.init(document.getElementById('chart4'))
      this.myChart5 = echarts.init(document.getElementById('chart5'))
      window.addEventListener('resize', () => {
        // this.myChart1.resize()
        // this.myChart2.resize()
        // this.myChart3.resize()
        // this.myChart4.resize()
        // this.myChart5.resize()
        this.setChart1()
        this.setChart2()
        this.setChart3()
        this.setChart4()
        this.setChart5()
      })
    },
    setChart1() {
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        toolbox: {},
        legend: {
          show: false,
        },
        grid: {
          left: '0',
          right: '0',
          top: '40',
          bottom: '20',
          containLabel: true,
        },
        color: [
          '#0095ff',
          '#3fafff',
          '#7fcaff',
          '#ff6836',
          '#ff895d',
          '#ffb217',
          '#ffcf6d',
          '#ffe2a8',
        ],
        xAxis: [
          {
            name: '(年)',
            data: this.dataAxis,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              lineStyle: {
                color: '#777C8B',
              },
            },
            axisTick: {
              lineStyle: {
                color: '#777C8B',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            // name: "(件)",
            nameLocation: 'end',
            min: 0,
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              formatter: '{value}',
              lineStyle: {
                color: '#C2C2C2',
              },
            },
          },
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: '#33D1B1', //改变折线点的颜色
              },
            },
            name: '',
            type: 'line',
            data: this.data1,
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#95E2CDFF',
                    },
                    {
                      offset: 0.9,
                      color: '#5AC6A8FF',
                      // 5AC6A8FF
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      }
      this.myChart1.setOption(option)
    },
    setChart2() {
      let option = {
        color: [
          '#0095ff',
          '#3fafff',
          '#7fcaff',
          '#ff6836',
          '#ff895d',
          '#ffb217',
          '#ffcf6d',
          '#ffe2a8',
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '0',
          right: '0',
          top: '20',
          bottom: '20',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.dataAxis2,
          axisLabel: {
            color: '#777C8B',
          },
          axisLine: {
            lineStyle: {
              color: '#777C8B',
            },
          },
          axisTick: {
            lineStyle: {
              color: '#777C8B',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#777C8B',
          },
          axisLine: {
            lineStyle: {
              color: '#C2C2C2',
            },
          },
        //   axisTick: {
        //     lineStyle: {
        //       color: '#777C8B',
        //     },
        //   },
        },
        series: [
          {
            data: this.data2,
            type: 'line',
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#0095ff', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#7fcaff', // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      }
      this.myChart2.setOption(option)
    },
    setChart3() {
      //园区企业专利有量排行
      // let option = {
      // 	tooltip: {
      // 		trigger: "axis",
      // 		axisPointer: {
      // 			type: "shadow"
      // 		}
      // 	},
      // 	legend: {
      // 		show: false
      // 	},
      // 	grid: {
      // 		left: "0",
      // 		right: "0",
      // 		top: "20",
      // 		bottom: "20",
      // 		containLabel: true
      // 	},
      // 	xAxis: {
      // 		// type: 'value',
      // 		type: "value",
      // 		show: false,
      // 		boundaryGap: [0, 0.01],
      // 		axisLabel: {
      // 			color: "#777C8B"
      // 		},
      // 		axisLine: {
      // 			lineStyle: {
      // 				color: "#777C8B"
      // 			}
      // 		},
      // 		axisTick: {
      // 			lineStyle: {
      // 				color: "#777C8B"
      // 			}
      // 		}
      // 	},
      // 	yAxis: {
      // 		type: "category",
      // 		data: this.data3,
      // 		inverse: true, //倒序排列
      // 		axisLabel: {
      // 			width: 40,
      // 			color: "#777C8B",
      // 			overflow: "truncate",
      // 			// ellipsis: '...'
      // 			formatter: function(value) {
      // 				return value.length > 6 ? value.substring(0, 6) + "..." : value
      // 			}
      // 		},
      // 		axisLine: {
      // 			lineStyle: {
      // 				color: "#777C8B"
      // 			}
      // 		}
      // 	},
      // 	series: [
      // 		{
      // 			name: "2020年",
      // 			type: "bar",
      // 			data: this.sum3,
      // 			itemStyle: {
      // 				normal: {
      // 					color: function(params) {
      // 						//柱状图的颜色
      // 						var colorList = [
      // 							"#0095FF",
      // 							"#59BAFF",
      // 							"#97D4FF",
      // 							"#33D1B1",
      // 							"#6EDAC4",
      // 							"#84DBC4",
      // 							"#0095FF",
      // 							"#59BAFF",
      // 							"#FFCF6D",
      // 							"#FFE5AF"
      // 							// '#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ff994d','#ffb217','#ffcf6d','#ffe2a8','#fff1a4'
      // 							// "#7EC0EE", "#FF9F7F", "#FFD700", "#E066FF", "#C0FF3E", "#7EC0EE", "#FF9F7F", "#FFD700", "#E066FF", "#C0FF3E"
      // 						]
      // 						return colorList[params.dataIndex]
      // 					}
      // 				}
      // 			}
      // 		}
      // 	]
      // }
      let option = {
        color: [
          '#0095ff',
          '#3fafff',
          '#7fcaff',
          '#ff6836',
          '#ff895d',
          '#ffb217',
          '#ffcf6d',
          '#ffe2a8',
        ],
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: '0',
          right: '0',
          top: '40',
          bottom: '20',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.dataAxis8,
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              lineStyle: {
                color: '#777C8B',
              },
            },
            axisTick: {
              lineStyle: {
                color: '#777C8B',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              lineStyle: {
                color: '#C2C2C2',
              },
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: 18,
            barMaxWidth: 18,
            data: this.data8.data8Num,
          },
        ],
      }

      this.myChart3.setOption(option)
    },
    setChart4() {
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}',
        },
        grid: {
          right: '80',
          left: '90',
          containLabel: true,
        },
        // legend: {
        // 	orient: "vertical",
        // 	type: "scroll",
        // 	top: "40",
        // 	right: "10" //右边字体间距
        // },
        color: [
          '#0095ff',
          '#3fafff',
          '#ff895d',
          '#ffb217',
          '#ffcf6d',
          '#ffe2a8',
        ],
        series: [
          {
            name: '',
            legalStatus: '',
            type: 'pie',
            radius: ['40%', '78%'],
            // right: "70", //左边图的间距
            // top: "5px",
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '10',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: this.datafourdata,

            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: '{b} : {c}',
                  fontSize: 10, // fontSize :10//文字的字体大小
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      }
      this.myChart4.setOption(option)
    },
    setChart5() {
      let option = {
        color: [
          '#0095ff',
          '#3fafff',
          '#7fcaff',
          '#ff6836',
          '#ff895d',
          '#ffb217',
          '#ffcf6d',
          '#ffe2a8',
        ],
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: '0',
          right: '0',
          top: '40',
          bottom: '20',
          containLabel: true,
        },
        // calculable: true,
        xAxis: [
          {
            name: '(年)',
            type: 'category',
            // data: this.dataAxis1,
            data: this.dataAxis5,
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              lineStyle: {
                color: '#777C8B',
              },
            },
            axisTick: {
              lineStyle: {
                color: '#777C8B',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            // name: "(件)",
            axisLabel: {
              color: '#777C8B',
            },
            axisLine: {
              lineStyle: {
                color: '#C2C2C2',
              },
            },
          },
        ],
        series: [
          {
            // name: '软企',
            barWidth: 18,
            barMaxWidth: 18,
            type: 'bar',
            data: this.data5.data5AxisY,
          },
        ],
      }
      this.myChart5.setOption(option)
    },
  },
}
</script>
